<template>
  <span v-if="!shouldShowTooltip">
    <span :style="textStyle">
      {{ displayText }}
    </span>
  </span>

  <v-tooltip
    v-else
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        :style="textStyle"
        v-bind="attrs"
        v-on="on"
      >
        {{ displayText }}
      </span>
    </template>

    <span :style="{ whiteSpace: 'pre-wrap', display: 'block', maxWidth: tooltipMaxWidth + 'px' }">
      {{ text }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "TruncateTooltip",
  props: {
    text: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 100,
    },
    textMaxWidth: {
      type: Number,
      default: 350,
    },
    tooltipMaxWidth: {
      type: Number,
      default: 350,
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
    tooltipOnlyWhenTruncated: {
      type: Boolean,
      default: false,
    },
    truncate: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    displayText() {
      if (!this.text) return "N/A";

      if (!this.truncate) {
        return this.text;
      }

      if (this.text.length <= this.limit) return this.text;

      return this.text.substring(0, this.limit) + "...";
    },

    isTruncated() {
      return this.truncate && this.text && this.text.length > this.limit;
    },

    shouldShowTooltip() {
      if (!this.showTooltip) return false;

      if (this.tooltipOnlyWhenTruncated) {
        return this.isTruncated;
      }

      return true;
    },

    textStyle() {
      if (this.truncate) {
        return {
          maxWidth: this.textMaxWidth + "px",
          display: "inline-block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        };
      }

      return {
        maxWidth: this.textMaxWidth + "px",
        display: "inline-block",
        whiteSpace: "normal",
        wordBreak: "break-word",
      };
    },
  },
};
</script>